import React from 'react';

class Instructions extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div id="instructions" className="instructions-container">
                    <div className="container ptb-100 d-flex flex-column align-items-center">
                        <h2>Downloading Instructions</h2>
                        <div>
                            <p>Please follow the instructions below to enable Auto and Beta Updates on the MRX x40 and AVM 70/90. Once done, the unit will update overnight to Network Module Version <b>1.109.164 or later</b>, allowing you to use the Anthem Remote App.</p>
                            <div>
                                <br></br>
                                <h3>Front Panel Menu</h3>
                                <p>1. Press Setup Button on Remote or Menu Button on Front Panel</p>
                                <p>2. Navigate to “Preferences”</p>
                                <p>3. Enable Auto Updates</p>
                                <p>4. Enable Beta Updates</p>
                                <p>5. Ensure “Connected Standby” is enabled</p>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Instructions;